import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');
export const HUBSPOT_CREDITS_PAGE_REDIRECT = gate('PPFE:HubspotCreditsPageRedirect');
export const EMEA_HSFM_PROMO_BANNER = gate('EMEAHSfMPromoBanner');
export const EMEA_HSFM_PROMO_BANNER_OVERFLOW = gate('EMEAHSfMPromoBannerOverflow');